import React, { PropTypes } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as specialistActions from '../../actions/specialistActions';
import Moment from 'react-moment';
// import { this.props.history } from 'react-router';
import * as constant from '../../constants/constant';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Bar, BarChart, Legend, Label, ScatterChart, Scatter, Area, AreaChart } from 'recharts';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import * as dashboardActions from "../../actions/dashboardActions";

const size = 10;
const styleIcon = {
	paddingRight: 10,
	cursor: 'pointer'
}
class MyFeedbackDetail extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			myFeedback: [],
			activePage: 1,
			count: size,
			totalCount: size,
			sortColumnName: '',
			sortOrder: -1,
			patientId: '',
			appointmentId: '',
			patientDetail: {},
			appointmentDate: '',
			appointmentTime: '',
			avgRate: 0,
			logoutButton: false
		}
		this.cancelFeeback = this.cancelFeeback.bind();
		this.addSpecialistFeedback = this.addSpecialistFeedback.bind();
		this.onLogoutclick = this.onLogoutclick.bind(this);

		this._logout = this._logout.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);



	}

	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}
	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}
	addSpecialistFeedback(event) {
		event.preventDefault();
		var doctorName = JSON.parse(localStorage.getItem('user'));

		var obj = {
			patientId: this.props.pId,
			appointmentId: this.props.appId,
			doctorFeedback: this.state.specialistComment,
			specialistId: localStorage.getItem('userId'),
			doctorName: doctorName.firstName + " " + doctorName.lastName
		}
		this.props.actions.respondToPatient(obj);
		this.props.callListAgain();
	}

	cancelFeeback() {
		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to cancel your response to the feedback?',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						this.props.history.push('/specialist/my-feedbacks');
					}
				},
				{
					label: 'No',
					onClick: () => { }
				}
			]
		})
	}
	componentWillMount() {
		var obj = {
			doctorId: localStorage.getItem('userId'),
			appointmentId: this.props.match.params.appointmentId,
			patientId: this.props.match.params.patientId
		}
		this.props.actions.getRatingDetail(obj);
	}

	componentWillReceiveProps(nextProps) {
		var state = this.state;
		state.myFeedback = nextProps.myFeedback;
		state.myRating = nextProps.myRating;
		state.patientData = nextProps.patientData;
		this.setState(state);
	}

	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}
	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}
	render() {
		var defaultImagePath = constant.PRODUCTION_IMAGE_URL + 'uploads/common/noUserImage.jpg';
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		if (user.image && user.image == constant.DEFAULT_USER_IMAGE) {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		if (this.state.patientData && this.state.patientData.length > 0) {
			var patientImage = this.state.patientData[0].profileImage == 'noUserImage.jpg' ? defaultImagePath : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + this.props.match.params.patientId + '/' + this.state.patientData[0].profileImage;
		}
		var rows = [];
		var myFeedback = [];
		myFeedback = this.state.myFeedback ? this.state.myFeedback : [];
		const data = [
		];
		if (this.state.myRating) {
			for (var i = 0; i < this.state.myRating.length; i++) {
				var obj = {
					name: this.state.myRating[i].ratingQId.question, rating: this.state.myRating[i].value
				}
				data[i] = obj;
			}
		}
		var userType = localStorage.getItem('userType');
		var condition = (((user.userName != undefined || user.gender != undefined) && user.availabilityCount > 0) && user.isVerified == '2');
		return (
			<div>
				<header className="main-header">
				<Link to={condition ? "/specialist/my-appointment" : null} className="logo">						<span className="logo-mini">{userType === 'specialist' ? <img src={require('../../images/img/logo_er_ms_specialist.png')} alt="" /> : <img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
						<span className="logo-lg">{userType === 'specialist' ? <img src={require('../../images/img/logo_er.png')} alt="" /> : <img src={require('../../images/img/logo_er_old.png')} alt="" />}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button"> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>

									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
				<div className="content-wrapper" >
					<section className="content container-fluid">
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB proCalendar">
									<div className="nav-tabs-custom">
										<ul className="nav nav-tabs">
											<li>
												<a href="#tab_1" data-toggle="tab" className="active show">My Feedback</a>
											</li>
										</ul>
										<div className="row">
											<div className="col-md-12">
												<div className="tab-content tabother">
													<div className="row">
														<div className="col-md-12">
															<div className="myfeedbackList">
																<div className="row">
																	<div className="col-md-2">
																		<img className="profile-user-img img-responsive img-circle" src={patientImage} alt="User profile picture" />
																		<p></p>
																	</div>
																	<div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
																		<h3 className="profile-username"><span className="hidden-xs name-capitalize">{this.state.patientData ? this.state.patientData[0].userId.userName : "User Name"}</span></h3>
																		<h4 className="profile-drr">
																			<Moment format="DD/MM/YYYY">{this.state.patientData ? this.state.patientData[0].dateOfBirth : ''}</Moment>
																			<br />
																			{this.state.patientData ? moment().diff(this.state.patientData[0].dateOfBirth, 'years') != 0 ? moment().diff(this.state.patientData[0].dateOfBirth, 'years') + " y/o" : moment().diff(this.state.patientData[0].dateOfBirth, 'months') + ' m/o' : ''}
																			{this.state.patientData ? " " + this.state.patientData[0].userId.gender : ''}</h4>
																	</div>
																	<div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
																		<BarChart width={450} height={200} data={data} >
																			<CartesianGrid strokeDasharray="3 3" />
																			<XAxis dataKey="name" interval={0} angle={70} />
																			<YAxis type="number" interval={0} domain={[0, 5]} />
																			<Tooltip />
																			<Bar dataKey="rating" fill="#82ca9d" barSize={25} />
																		</BarChart>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div className="myfeeback contxt">
														<div className="row">
															<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
																<h4>My Feedback</h4>
																<p>{this.state.myFeedback && this.state.myFeedback.patientFeedback}</p>
															</div>
														</div>
													</div>
													<div className="yourResponse contxt">
														<div className="row">
															<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
																<h4>Your Response</h4>
																<textarea placeholder="Type here" className="form-control textara"></textarea>
															</div>
														</div>
													</div>
													<div className="myfeedbtns">
														<div className="row">
															<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
																<div className="bottomBtn">
																	<button type="button" className="btn btn-warning btn-lg" data-toggle="modal" data-target="#modal-default">Respond</button>  <button type="button" onClick={this.cancelFeeback} className="btn btn-cancel btn-default btn-lg">Cancel</button>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>

					<div className="Copyrightafterlogin">
						<p>Medfix &copy; 2018. All rights reserved</p>

					</div>
				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		myFeedback: state.specialist.myFeedbackDetail.feedbackDetail,
		myRating: state.specialist.myFeedbackDetail.ratingDetail,
		patientData: state.specialist.myFeedbackDetail.patientData,
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(specialistActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)


	};
}
export default connect(mapStateToProps, mapDispatchToProps)(MyFeedbackDetail);
